import React, { memo, ReactNode } from 'react';
import { ShipmentItem } from '@/features/ShipmentView/types';
import { ShipmentViewContext, useShipmentViewProvider } from './context';

const ShipmentViewProvider = memo(
  ({ children, shipmentItem }: { children: ReactNode; shipmentItem: ShipmentItem }) => {
    const data = useShipmentViewProvider({ shipmentItem });
    return <ShipmentViewContext.Provider value={data}>{children}</ShipmentViewContext.Provider>;
  }
);
export default ShipmentViewProvider;
